import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { summarizeActivityItemNames } from 'tripPlanner/assistant/surfaceSnapshots/summarizeActivityItemNames'

// occurredAt is the caller's timestamp, not one taken here -- see buildItemDeletedActivityEntry
// for why (same delete-request-await shape).
export function buildItemsBulkDeletedActivityEntry(itemNames: ReadonlyArray<string>, sourcePath: string, occurredAt: string): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'items_bulk_deleted',
    label: 'Deleted itinerary items',
    displayText: boundActivityDisplayText(`Removed ${summarizeActivityItemNames(itemNames)} from the itinerary`),
    sourcePath,
    dataClassification: 'personalised_surface',
    occurredAt,
  }
}
